/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetEmailConfigTeamDto
 */
export interface GetEmailConfigTeamDto {
    /**
     * 
     * @type {string}
     * @memberof GetEmailConfigTeamDto
     */
    id: string;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetEmailConfigTeamDto
     */
    team: GetTeamDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmailConfigTeamDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetEmailConfigTeamDto interface.
 */
export function instanceOfGetEmailConfigTeamDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "team" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetEmailConfigTeamDtoFromJSON(json: any): GetEmailConfigTeamDto {
    return GetEmailConfigTeamDtoFromJSONTyped(json, false);
}

export function GetEmailConfigTeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmailConfigTeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'team': GetTeamDtoFromJSON(json['team']),
        'active': json['active'],
    };
}

export function GetEmailConfigTeamDtoToJSON(value?: GetEmailConfigTeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'team': GetTeamDtoToJSON(value.team),
        'active': value.active,
    };
}

